import * as React from "react"
import styled from "styled-components"

const Container = ({ children }) => {
  return (
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 960,
        padding: `0 1.0875rem 1.45rem`,
      }}
    >
      {children}
    </div>
  )
}

export const TitleText = styled.span`
  font-size: 62px;
  display: block;
  letter-spacing: -1;
  font-weight: 900;
  line-height: 1.2;
  word-break: keep-all;
  max-width: 700;
  margin: 0 auto;
  @media screen and (max-width: 460px) {
    font-size: 38px;
  }
`
export const ContainerWithBackground = ({
  containerStyle,
  backgroundColor,
  children,
}) => {
  return (
    <div
      style={{
        margin: `0 auto`,
        maxWidth: 1200,
        position: "relative",
      }}
    >
      <div
        style={{
          position: "relative",
          margin: `0 auto`,
          maxWidth: 960,
          zIndex: 10,
          ...containerStyle,
        }}
      >
        {children}
      </div>
      <div
        style={{
          position: "absolute",
          borderRadius: 20,
          backgroundColor: backgroundColor || "rgba(0, 0, 0, 0.05)",
          top: "30%",
          bottom: 50,
          left: 0,
          right: 0,
          zIndex: 1,
        }}
      ></div>
    </div>
  )
}

const RowContainer = styled.div`
  margin: 8rem 0;
  flex-direction: row;
  display: flex;
  align-items: center;
  position: relative;
  .section,
  .gatsby-image-wrapper {
    position: relative;
    z-index: 50;
  }
  @media screen and (min-width: 1200px) {
    :after {
      width: 500px;
      height: 500px;
      border-radius: 100%;
      content: "";
      display: block;
      position: absolute;
      background-color: #f9f9f1;
      top: 100px;
      ${props => (props.reversed ? "left" : "right")}: -100px;
      z-index: 0;
    }
  }
  @media screen and (max-width: 600px) {
    :after {
      display: none;
    }
    flex-direction: column;
    .section {
      position: relative;
      top: -150px;
      margin-bottom: -150px;
      z-index: 100;
      background-color: rgba(255, 255, 248, 1);
      margin-top: 2rem;
      order: 1 !important;
      padding-top: 2rem;
      > div {
        padding: 0 !important;
        text-align: center;
      }
      :before {
        content: "";
        background: linear-gradient(
          180deg,
          rgba(255, 255, 248, 0),
          rgba(255, 255, 248, 1)
        );
        height: 200px;
        width: 100%;
        position: absolute;
        top: -200px;
      }
    }
    .gatsby-image-wrapper {
      width: 80%;
    }
  }
`

export const ContainerWithImage = ({
  title,
  reversed = false,
  children,
  desc,
}) => {
  return (
    <RowContainer reversed={reversed}>
      <div
        className={"section"}
        style={{
          flex: 2,
          order: reversed ? 2 : 0,
        }}
      >
        <div
          style={{
            paddingLeft: reversed ? 40 : 0,
            paddingRight: reversed ? 0 : 40,
          }}
        >
          <h2 style={{ color: "#4c00d1", wordBreak: "keep-all" }}>{title}</h2>
          <p
            style={{
              color: "#b16b6b",
              lineHeight: 1.6,
              fontSize: 24,
              wordBreak: "keep-all",
            }}
          >
            {desc}
          </p>
        </div>
      </div>
      {children}
    </RowContainer>
  )
}

export const Cards = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: -1rem;
  margin-right: -1rem;
  margin-bottom: 4rem;
  @media screen and (max-width: 600px) {
    display: block;
  }
`

const CardContainer = styled.div`
  flex: 0 0 33.3333%;
  position: relative;
  :after {
    width: 5px;
    height: 5px;
    border-radius: 100%;
    content: "";
    display: block;
    position: absolute;
    background-color: #f0e7f5;
    top: 20px;
    left: 10px;
    z-index: 0;
  }
  > div {
    position: relative;
    z-index: 1;
  }
  @media screen and (max-width: 900px) {
    flex: 0 0 50%;
  }
  padding: 1rem;
  margin: 0.5rem 0;
  .title {
    font-weight: 700;
    margin-bottom: 0.5rem;
    color: #333333;
    word-break: keep-all;
  }
  .desc {
    font-size: 0.9rem;
    color: #555555;
    margin: 0;
    word-break: keep-all;
  }
`

export const Card = ({ title, desc }) => {
  return (
    <CardContainer>
      <div>
        <p className={"title"}>{title}</p>
        <p className={"desc"}>{desc}</p>
      </div>
    </CardContainer>
  )
}

export default Container
